import { render, staticRenderFns } from "./DeleteCartOrCheckoutDialog.vue?vue&type=template&id=1af64afe&"
import script from "./DeleteCartOrCheckoutDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteCartOrCheckoutDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteCartOrCheckoutDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports